import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://cabil.co";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

/**
 * Per-route SEO tags (title, description, keywords, canonical, Open Graph,
 * Twitter Card) plus optional JSON-LD structured data. This app is a CRA SPA
 * with a single static <head> in public/index.html — without this, every
 * route (blog posts included) shares one identical title/description in
 * search results and social shares. Mount one <Seo> per page component.
 */
export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes("Cabil") ? title : `${title} | Cabil`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Cabil" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
